export default "__VITE_ASSET__BoeJE2sM__"